import React from 'react';

const TechnicalAssistanceDetails = ({ ticket, formatDate }) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-blue-600 mb-4 font-poppins">
          Technical Assistance Details
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-4">
          <div className="py-2">
            <div className="text-sm font-medium text-gray-600 mb-1 font-poppins">Name</div>
            <div className="text-gray-900 font-poppins">{ticket.name || 'N/A'}</div>
          </div>
          <div className="py-2">
            <div className="text-sm font-medium text-gray-600 mb-1 font-poppins">Email</div>
            <div className="text-gray-900 font-poppins">{ticket.email || 'N/A'}</div>
          </div>
          <div className="py-2">
            <div className="text-sm font-medium text-gray-600 mb-1 font-poppins">TA Type</div>
            <div className="text-gray-900 font-poppins">{ticket.taType?.name || ticket.categorySpecificDetails?.details?.taType || 'Not specified'}</div>
          </div>
        </div>
        <div className="space-y-4">
          {Object.entries(ticket.categorySpecificDetails?.details || {}).map(([key, value]) => {
            // Skip these fields as they're already shown elsewhere
            if (!value || ['location', 'schoolLevel', 'schoolName', 'department', 'type', 'taType'].includes(key)) return null;
            return (
              <div key={key} className="py-2">
                <div className="text-sm font-medium text-gray-600 mb-1 font-poppins">
                  {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                </div>
                <div className="text-gray-900 font-poppins">
                  {key.toLowerCase().includes('date') 
                    ? formatDate(value)
                    : typeof value === 'object' 
                      ? JSON.stringify(value) 
                      : String(value)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="mt-6">
        <div className="py-2">
          <div className="text-sm font-medium text-gray-600 mb-2 font-poppins">Message</div>
          <div className="bg-white p-4 rounded-lg border border-gray-200 text-gray-900 whitespace-pre-wrap font-poppins">
            {ticket.message || 'Not provided'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnicalAssistanceDetails; 